"use client"

import { Skeleton } from "@/components/ui/skeleton"
import React from "react"

export const ServiceSidebarSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-5 py-8">
      {[1, 2, 3].map(item => (
        <div key={item} className="pb-5 border-b border-[rgba(0, 0, 0, 0.9)]">
          <div className="grid grid-cols-1 sm:grid-cols-12">
            {/* Left Side - Job Details */}
            <div className="col-span-5 sm:pr-[0.9375rem] flex flex-col sm:gap-[0.9375rem] gap-[0.3125rem]">
              <Skeleton className="h-6 w-3/4 mb-[0.625rem] sm:mb-0" />
              {[1, 2, 3, 4].map(detail => (
                <div key={detail} className="flex items-center gap-[0.625rem]">
                  <Skeleton className="w-4 h-4 rounded" />
                  <Skeleton className="h-4 w-32" />
                </div>
              ))}
            </div>

            {/* Right Side - Company Info */}
            <div className="col-span-5 sm:px-[0.9375rem] mt-5 sm:mt-0 flex gap-[1.875rem] items-center">
              <Skeleton className="w-[6.25rem] h-[6.25rem] rounded-lg" />
              <div className="flex flex-col gap-[0.9375rem]">
                <Skeleton className="h-5 w-40" />
                <div className="flex items-center gap-[0.625rem]">
                  <Skeleton className="w-4 h-4 rounded" />
                  <Skeleton className="h-4 w-32" />
                </div>
              </div>
            </div>

            {/* Button Section */}
            <div className="col-span-2 sm:pl-[0.9375rem] mt-5 sm:mt-0 flex items-center">
              <Skeleton className="w-[8.40625rem] h-[2.25rem] rounded" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}


